import { React, useEffect, useState, useRef, useMemo, useCallback,useContext} from "react";
import { getPatientRequests } from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
import AppContext from "../../AppContext";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
const PatientListForRoom = (props) => {
     const global = useContext(AppContext);
  const history = useHistory();
  const { room } = (props.location && props.location.state) || {};
  const [isLoading, setIsLoading] = useState(false);
  const [patients, setpatients] = useState([]);

  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  
  // Helper function to get today's date in YYYY-MM-DD format
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  const [from_date, setFrom_date] = useState(getTodayDate())
  const [to_date, setTo_date] = useState(getTodayDate())


  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

  useEffect(() => {
    getPatientListForRoom();

    return () => {};
  }, []);



     const onBtExport = useCallback((e) => {
          setIsLoading(true);
          gridRef.current.api.exportDataAsCsv(
              { allColumns: true });
  
            
      }, []);
  const getPatientListForRoom = () => {
    setIsLoading(true);

    let payload = {
      room_id: room.room_id,
      hospital_id: room.hospital_id,

      from:from_date?? window.formatDate(new Date()),
      to:to_date?? window.formatDate(new Date()),
    };

    console.log(payload);
    getPatientRequests(payload)
      .then((res) => {
        console.log(res);
        setIsLoading(false);

        if (res.status == 200) {
          var response = res.data;
          console.log("---------********************-------");
          console.log(res.data);

          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            // console.log("************");
            console.log(response.data);
            response.data?.map((p) => {
              let patient = JSON.parse(p.visit_info);
              _data.push({
                patient_id: p.patient_id,
                visit_id: p.visit_id,
                service_request_id: p.id,
                visit_count: p.visit_count,
                name:patient.name ,
                dob: patient.date_of_birth,
                phone: patient.contact_telephone,
                created_at:p.created_at                ,
                village:patient.village,
                created_by:p.created_by_user?.name
              });
            });

            setRowData(_data);
          } else {
            cogoToast.error("Err=" + res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  return (
    <div>
      <h1>Patient List</h1>
      {/* {JSON.stringify(room)} */}
      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/hmis"> HMIS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/hmis"> Hospitals </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <span> {room.name} </span>
        </BreadcrumbItem>
      </Breadcrumb>
      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div>
      <div className="card-body">
        <div className="ag-theme-alpine">
         <div className="row" style={{width:"50%"}}>
          <div className="col-md-1">
            From
          </div>
          <div className="col-md-3">
            <input 
              type="date" 
              className="form-control" 
              value={from_date}
              onChange={(e)=>setFrom_date(e.target.value)}
            />
          </div>
          <div className="col-md-1">
            To
          </div>
          <div className="col-md-3">
            <input 
              type="date" 
              className="form-control" 
              value={to_date}
              onChange={(e)=>setTo_date(e.target.value)}
            />
          </div>
          
          <div className="col-md-2">
           <button className="btn btn-primary" onClick={()=>getPatientListForRoom()}>View</button>
          </div>
 
        {global.get_logged_in_user().id == "474"  &&   <div className="col-md-2">
              <a href="javascript:void(0)" onClick={onBtExport}  className="btn btn-success" >
                                            Export
                                        </a>
          </div> }
         </div>
<br/>

          <AgGridReact
            suppressMenuHide={true}
            onRowDoubleClicked={(e) => {
              if (!e.data) {
                return;
              }

              let serial_no = room.serial_no;

              if (serial_no == "10") {
                // lab
                history.push({
                  pathname: "/hmis/lab-result-form",
                  state: {
                    room: room,
                    patient_info: e.data,
                  },
                });
              } else {
                history.push({
                  pathname: "/hmis/consultation-form",
                  state: {
                    room: room,
                    patient_info: e.data,
                  },
                });
              }
            }}
            ref={gridRef}
            //   overlayLoadingTemplate={
            //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
            //   }

            overlayLoadingTemplate={
              '<span className="ag-overlay-loading-center"> loading data...</span>'
            }
            onGridReady={(params) => {
              setGridApi(params.api);
              params.api.showLoadingOverlay();
            }}
            rowData={rowData}
            domLayout={"autoHeight"}
            animateRows={true}
            pagination={true}
            paginationPageSize={100}
            defaultColDef={defaultColDef}
            resizable={true}
            enableCellTextSelection={true}
            suppressCellSelection={true}
            columnDefs={[
              {
                headerName: "#",
                filter: false,
                maxWidth: 70,
                sortable: true,
                valueFormatter: function (params) {
                  return `${parseInt(params.node.id) + 1}`;
                },
              },
              {
                headerName: "Visit No.",
                field: "visit_count",
                sortable: true,
                maxWidth: 150,

                filter: true,
              },
              {
                headerName: "Name",
                field: "name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Phone ",
                field: "phone",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Village",
                field: "village",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Date/Time",
                field: "created_at",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Created by",
                field: "created_by",
                sortable: true,
                filter: true
            
              },
              
             
            ]}
          ></AgGridReact>
         
        </div>
      </div>
      ;
    </div>
  );
};

export default PatientListForRoom;
